<div>
  <section>
    <div class="bold" i18n="@@WatchedRegisterComponentTitle">
      Watched Registers
    </div>
    <mat-checkbox
      color="primary"
      class="margin"
      i18n="@@WatchedRegisterComponentInternationCheckbox"
      [(ngModel)]="order.iSkip"
      [ngModelOptions]="{ standalone: true }"
    ></mat-checkbox>
    <span
      class="checkbox-label-text"
      i18n="@@WatchedRegisterComponentInternationCheckbox"
    >
      Only report the international trademarks designating (published in) the
      countries/regions watched
    </span>
  </section>
</div>
<div class="watched-register">
  <div class="division-container">
    <div class="division watched-register-list">
      @for (register of region; track register) {
      <div
        (click)="loadRegisters(register)"
        [ngClass]="{ selected: registerKey === register }"
        class="watched-register content"
      >
        <div class="regions">
          <div>{{ register }}</div>
          <div>
            {{ getCount(register) }}/{{ watchRegisters[register].length }}
            <ng-container i18n="@@WatchedRegisterComponentSelected">
              Selected</ng-container
            >
          </div>
        </div>
        <div>
          <mat-icon>keyboard_arrow_right</mat-icon>
        </div>
      </div>
      }
    </div>
    <div class="division">
      <form class="form">
        <mat-form-field subscriptSizing="dynamic" class="search-bar">
          <mat-icon matPrefix id="search-icon">search</mat-icon>
          <input
            matInput
            #searchInput
            placeholder="Search for a country/region..."
            i18n-placeholder="@@WatchedRegisterComponentSearchPlaceholder"
            name="search"
            (keyup)="onSearch(searchInput.value)"
          />
        </mat-form-field>
        <div class="list_container">
          <mat-selection-list class="filtered-register-list">
            @if (this.filteredRegisters.length > 0) {
            <mat-checkbox
              class="selectAll"
              color="primary"
              [(ngModel)]="allSelected"
              [ngModelOptions]="{ standalone: true }"
              (change)="toggleSelectAllOptions()"
            >
              <span>
                {{ this.search }}
                <ng-container i18n="@@WatchedRegisterComponentSelectAll"
                  >Select All</ng-container
                ></span
              >
            </mat-checkbox>
            } @else {
            <h5>No matches.</h5>
            } @for (register of filteredRegisters; track register) {
            <div>
              <mat-checkbox
                color="primary"
                [value]="register"
                [checked]="isSelected(register)"
                (change)="toggleSelectOptions(register)"
              >
                {{ register }}
              </mat-checkbox>
            </div>
            }
          </mat-selection-list>
        </div>
      </form>
    </div>
  </div>
</div>
